// extracted by mini-css-extract-plugin
export default {"tab-group":"Tab_tab-group__+93dO","tab":"Tab_tab__3MMHu","active":"Tab_active__2vM6g"};